import React, { FC } from "react";
import { saveDS160PreviousUSTravelObj } from "../../../../../../api/ds160/types";
import ReviewBox from "../../../../components/Review/ReviewBox";
import { FormDS160Progress } from "../../types";
import { GenericDs160ReviewProps } from "./DownloadPage";
import PdfReviewBox from "../../../../components/Review/Pdf Review/PdfReviewBox";
import { ReviewPreviousUSSection } from "./data";

interface Props extends GenericDs160ReviewProps {
  data?: saveDS160PreviousUSTravelObj;
}

const ReviewPreviousUS: FC<Props> = ({ title, data, isDownload }) => {
  const section = data ? ReviewPreviousUSSection(data) : [];

  const compProps = {
    title: title,
    data: section,
    editUrl: FormDS160Progress.previousUSTravel,
  };

  return isDownload ? (
    <PdfReviewBox {...compProps} />
  ) : (
    <ReviewBox {...compProps} />
  );
};

export default ReviewPreviousUS;
